import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Import all reducers here
import authReducer from "./slice/AuthSlice";
import themeReducer from "./slice/ThemeSlice";
import endpointRequestsReducer from "./slice/EndpointRequestsSlice";
import userReducer from "./slice/user-management/userSlice";
import rolesAndPermissionsReducer from "./slice/rolesAndPermissions/slice";
import memoryBookReducer from "./slice/MemoryBookSlice";
import bugReducer from "./slice/bug-fix/bugSlice";
import referralAuthReducer from "./slice/ReferralAuthSlice";
import countryReducer from "./slice/CountrySlice";
import { footerConfigApi } from "../service/footerConfigApi";
// import otherReducer from './slice/OtherSlice'; (if any)

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer, // Add this line
  endpointRequests: endpointRequestsReducer,
  users: userReducer,
  rolesAndPermissions: rolesAndPermissionsReducer,
  memoryBook: memoryBookReducer,
  bugs: bugReducer,
  referralAuth: referralAuthReducer,
  country: countryReducer,
  [footerConfigApi.reducerPath]: footerConfigApi.reducer,
});

// Persist config for the whole root state
const persistConfig = {
  key: "root",
  storage,
  blacklist: [footerConfigApi.reducerPath, 'country'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(footerConfigApi.middleware),
});

// Create persistor
export const persistor = persistStore(store);

// RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;